<template>
  <TableTemplate
    v-model="tableResult"

    :columns="tableColumns"
    :columnVariables="tableColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"
    :selected="selected"
    :enable-sorting="true"
    
    newly-created-alert-key="website"

    :page="page"
    :max="max"

    :on-row-click="editDiscount"
    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"

    ref="table"
  >
    <!-- <template #new-item-alert-content="{name, uid}">
      U heeft een nieuw <router-link :to="`/admin/websites/edit/${uid}`">{{ name }}</router-link> website.
    </template> -->

    <template #above>
      <TableHeader v-model="selecting"
        title="Kortingen"
        :showButton="showButton"
        :refetch="refetch"
        :exportParams="exportEndpointParams"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addDiscount"
          >
            Korting toevoegen
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template v-if="loaded" #row-action="{item}">
      <div class="delete-icon" @click="confirmDelete(item)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </div>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen kortingen"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
  
          <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
              <g>
                <line x1="7" y1="10.02" x2="7" y2="11.03" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                <line x1="7" y1="5.01" x2="7" y2="5.95" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
              </g>
              <path d="M7,13.49c3.5,0,6-1.24,6-4,0-3-1.5-5-4.5-6.5L9.68,1.47a.66.66,0,0,0-.56-1H4.88a.66.66,0,0,0-.56,1L5.5,3C2.5,4.51,1,6.51,1,9.51,1,12.25,3.5,13.49,7,13.49Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
              <path d="M6,9.56A1.24,1.24,0,0,0,7,10,1.12,1.12,0,0,0,8.19,9,1.12,1.12,0,0,0,7,8,1.12,1.12,0,0,1,5.81,7,1.11,1.11,0,0,1,7,6,1.26,1.26,0,0,1,8,6.4" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
            </g></g>
        </svg>
      </EmptyStatePlaceholder>
    </template>

  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import TableCell from "src/components/Table/TableCell.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import FormToggleSwitch from "/src/components/Inputs/FormToggleSwitch"
import FormButtonCheckbox from "src/components/Inputs/FormButtonCheckbox.vue"
import EditablePrice from '../layout/EditTableItem/EditablePrice.vue'
import MultipleSelectOptions from '../layout/Table/MultipleSelectOptions.vue'
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import HeaderButton from "src/components/Inputs/HeaderButton.vue"

import table from "src/mixins/table"
import selectMultipleItems from "src/mixins/selectMultipleItems"

export default {
  metaInfo: {
    title: "Kortingen",
  },
  components: {
    RefreshBtn,
    MultipleSelectOptions,
    TableCell,
    FormToggleSwitch,
    TableHeader,
    TableMainSearchField,
    EditablePrice,
    TableSearchField,
    FormSelect,
    EmptyStatePlaceholder,
    TableTemplate,
    FormButtonCheckbox,
    HeaderButton,
    TableActionDropdown,
  },
  mixins: [
    selectMultipleItems,
    tableFieldOptions,
    table({
      pageReference: 'discounts',

      defaultColumnSizes: {
        startDate: 130,
        endDate: 130,
        products: 170,
      },
      columnTranslationMaps: {
        "Naam": "name",
        "Begindatum": "startDate",
        "Einddatum": "endDate",
        "Type": "type",
        "Coupon code": "couponCode",
        "Producten": "products",
      },

      defaultColumns: [
        "Naam", "Begindatum", "Einddatum", "Type", "Coupon code", "Producten",
      ],
      columnConfigurationId: "discounts",


      params: {
        name: "",
        search: "",
      },
      route: "/api/discounts",
    }),
  ],
  methods: {
    editDiscount(discount) {
      this.$pushModal({
        modal: "EditDiscount",
        toBind: {
          discount,
          callback: this.freshRefetch,
        },
      })
    },
    addDiscount() {
      this.$pushModal({
        modal: "AddDiscount",
        toBind: {
          callback: this.freshRefetch,
        },
      })
    },
    
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteDiscount(item.uid),
        {
          title: "Korting verwijderen",
          description: `Weet u zeker dat u de korting <b>${item.name}</b> wilt verwijderen?`,
          buttonSave: "Verwijderen",
        }
      )
    },
    async deleteDiscount(uid) {
      await this.$handlePromise(async () => {
        await this.axios.delete(`/api/discounts/${uid}`)

        this.$success("Website verwijderd!")
        this.freshRefetch()
      })
    },
  },
  computed: {
    capitalize() {
      return [false, true, true, true]
    },
  },
}

</script>

<style scoped>

</style>
